declare let process: any;
declare let global: any;

/**
 *
 * Determine if we are executing in Browser or Node
 *
 */
const hasProcess = (typeof process === 'object') && process.env;
export const isNode = (hasProcess && Object.prototype.toString.call(process) === '[object process]');
export const isBrowser = !isNode;

/**
 * Resolve the global var for the current runtime, node or browser
 */
function getGlobal() {
  return isNode ? global : (window || {});
}

/**
 * Isomorphic retreival of a global variable
 *  - with an optional default value as fallback.
 *
 * For browsers it's read from 'window'
 * For node.js it's read from 'global'
 *
 * @param {string} name - The global variable to lookup
 * @param {any} defaultValue - if [name] is null, emtpy or undefined then defaultValue will be returned
 */
export function globalVar(name: string, defaultValue?: any) {
  const globalObj = getGlobal();
  if (defaultValue !== undefined && !globalObj.hasOwnProperty(name)) {
    globalObj[name] = defaultValue;
  }
  return globalObj[name];
}

/**
 *
 * Determine if we are executing in development or production environment.
 * Use the value for NODE_ENV replaced by webpack when bundling
 *
 */
export const isDevelopment = (process.env.NODE_ENV as string).trim().toLowerCase() !== 'production';
